module.exports = __webpack_public_path__ + "img/1.29c055a5.png";